/*
 * @Author: Mufaddal Jamali
 * @Date: 2020-02-24 15:49:21
 * @Last Modified by: Mufaddal Jamali
 * @Last Modified time: 2020-11-03 11:15:07
 */

import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";
import * as handler from "../utils/handler";

class Preparation extends Component {
  URL = window["app-config"].URL.preparationLocationUrl;
  defaultLanguage = window["app-config"].defaultLang;
  state = { lang: {} };
  componentDidMount() {
    this.setState({ lang: handler.setTranslations() });
  }

  render() {
    console.log("ARRAY: ", this.state.lang.Preparations);
    return (
      <div className="booking-summary-prep">
        <p>
          <strong>{this.state.lang.Preparation}</strong>
        </p>
        <ol>
          {/* <li>{ReactHtmlParser(this.state.lang.PrepOne)}</li>
          <li>{ReactHtmlParser(this.state.lang.PrepTwo)}</li>
          <li>{ReactHtmlParser(this.state.lang.PrepThree)}</li>
          <li>{ReactHtmlParser(this.state.lang.PrepFour)}</li>
          <li>{ReactHtmlParser(this.state.lang.PrepFive)}</li> */}
          {this.state.lang.Preparations !== undefined &&
            this.state.lang.Preparations.map((data, index) => (
              <li key={index}>{ReactHtmlParser(data.text)}</li>
            ))}
        </ol>

        <p>
          <strong>
            {ReactHtmlParser(this.state.lang.SecondaryPrepHeading)}
          </strong>
        </p>
        <ol>
          <li>{ReactHtmlParser(this.state.lang.SecondaryPrepOne)}</li>
          <li>{ReactHtmlParser(this.state.lang.SecondaryPrepTwo)}</li>
        </ol>
      </div>
    );
  }
}

export default Preparation;
